import { render, staticRenderFns } from "./gdprModal.vue?vue&type=template&id=0bf21d34"
import script from "./gdprModal.vue?vue&type=script&lang=js"
export * from "./gdprModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports